var uA = window.navigator.userAgent,
  // @ts-ignore
  isIE = /msie\s|trident\/|edge\//i.test(uA) && !!(document.uniqueID || document.documentMode || window.ActiveXObject || window.MSInputMethodContext)
export default isIE


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/svgd/IE.js